"use client";

import { useState, useSyncExternalStore } from "react";
import Image from "next/image";
import Reveal from "./Reveal";

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

function subscribeToReducedMotion(onChange: () => void) {
  const query = window.matchMedia(REDUCED_MOTION);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

export default function MeetSection() {
  // The server renders the still frame, so the looping GIF never loads under reduced motion.
  const reducedMotion = useSyncExternalStore(
    subscribeToReducedMotion,
    () => window.matchMedia(REDUCED_MOTION).matches,
    () => true,
  );
  const [choice, setChoice] = useState<boolean | null>(null);
  const playing = choice ?? !reducedMotion;

  return (
    <section className="block" id="meet">
      <div className="wrap">
        <Reveal className="meet2">
          <div className="meet2-phone">
            <Image
              src={
                playing
                  ? "/lh-v2/lh-landing-phone.gif"
                  : "/lh-v2/lh-landing-phone-still.png"
              }
              alt="RCS text conversation with My Health Co: a card offers a lab appointment, the member picks Tomorrow 8 AM, and the appointment is confirmed"
              width={600}
              height={1111}
              className="rcs-img"
            />
            <button
              type="button"
              className="btn-ghost"
              onClick={() => setChoice(!playing)}
            >
              {playing ? "Pause animation" : "Play animation"}
            </button>
          </div>
          <div className="meet2-copy">
            <span className="eyebrow">Meet Logical Health</span>
            <h2 className="serif">
              Healthcare guidance that meets members{" "}
              <em className="hl">where they are</em>
            </h2>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
